module.exports = __webpack_public_path__ + "static/lau-cover-bg-f614b8381a512c3758508c572a55c8e9.jpg";